import React from 'react'
import PropTypes from 'prop-types'
import { usePipelineDataContextWithVariables } from '../provider/DDPDataProvider'
import Loading from '../../../molecules/Loading'

function DDPLoader ({ pipeline, variables, children }) {
  const { isLoading, error } = usePipelineDataContextWithVariables(pipeline, variables)

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : error ? null : children}
    </>
  )
}

DDPLoader.propTypes = {
  /** The data pipeline to execute */
  pipeline: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),

  variables: PropTypes.object,
  children: PropTypes.node
}

export default DDPLoader
